/* eslint-disable react/prop-types */
/** @jsxRuntime classic */
/** @jsx jsx */
import PropTypes from 'prop-types';
import { jsx, css } from '@emotion/core';
import { useColor as colors } from "../../../theme";
const Path = ({
  data,
  getX,
  getY,
  Smooth,
  PathVisible,
  STROKE,
  STROKEHover,
  pathColor,
  unitWidth
}) => {
  const point = data.map(element => {
    const x = getX(element.x + unitWidth / 1.5);
    const y = getY(element.quantity);
    return [x, y];
  });

  // const Colors = data.map(element => {
  //     const colors = element.color;
  //     return colors;
  // });

  const PathCSS = css`
        stroke: ${colors[pathColor] || pathColor};
        stroke-width: ${STROKE};
        stroke-linecap: round;
        stroke-linejoin: round;
        /* &:hover {
            cursor: pointer;
            stroke: ${colors[pathColor] || pathColor};
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: ${STROKEHover};
        } */
    `;

  // Properties of a line
  // I:  - pointA (array) [x,y]: coordinates
  //     - pointB (array) [x,y]: coordinates
  // O:  - (object) { length: l, angle: a }: properties of the line
  const line = (pointA, pointB) => {
    const lengthX = pointB[0] - pointA[0];
    const lengthY = pointB[1] - pointA[1];
    const Balance = 0.005 * Math.PI;
    const Re = 0.38 * Math.PI;
    let angle = Math.atan2(lengthY, lengthX);
    if (angle < -0.32 * Math.PI) {
      angle += Re; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    }

    if (angle > 0.16 * Math.PI) {
      angle -= Balance;
    }

    // console.log(angle);

    return {
      length: Math.sqrt(Math.pow(lengthX, 2) + Math.pow(lengthY, 2)),
      angle
    };
  };

  // Position of a control point
  // I:  - current (array) [x, y]: current point coordinates
  //     - previous (array) [x, y]: previous point coordinates
  //     - next (array) [x, y]: next point coordinates
  //     - reverse (boolean, optional): sets the direction
  // O:  - (array) [x,y]: a tuple of coordinates
  const controlPoint = (current, previous, next, reverse) => {
    // When 'current' is the first or last point of the array
    // 'previous' or 'next' don't exist.
    // Replace with 'current'
    const c = current;
    const p = previous ? previous : c;
    const n = next ? next : c;
    // The smoothing ratio
    const smoothing = 0.15;
    // Properties of the opposed-line
    const o = line(p, n);
    // If is end-control-point, add PI to the angle to go backward
    const rev = reverse ? Math.PI : 0;
    // The control point position is relative to the current point
    const x = c[0] + Math.cos(o.angle + rev) * o.length * smoothing;
    const y = c[1] + Math.sin(o.angle * 0.095 + rev) * o.length * smoothing;
    return [x, y];
  };
  const svgPathRender = point => {
    const d = point.reduce((acc, e, i, a) => {
      if (i > 0) {
        const cs = controlPoint(a[i - 1], a[i - 2], e);
        const ce = controlPoint(e, a[i - 1], a[i + 1], true);
        return `${acc} C ${cs[0]},${cs[1]} ${ce[0]},${ce[1]} ${e[0]},${e[1]}`;
      } else {
        return `${acc} M ${e[0]},${e[1]}`;
      }
    }, '');
    return jsx("path", {
      d: d,
      css: PathCSS,
      fill: 'none'
    });
  };
  const command = point => `L ${point[0]} ${point[1]} `;
  const svgPath = points => {
    // build the d attributes by looping over the points
    const d = points.reduce((acc, point, i, a) => i === 0 ?
    // if first point
    `M ${point[0]},${point[1]}` :
    // else
    `${acc} ${command(point, i, a)}`, '');
    return jsx("path", {
      d: d,
      css: PathCSS,
      fill: 'none'
    });
  };
  return PathVisible ? jsx("g", {
    className: 'DGN-Path-LineChart'
  }, Smooth ? svgPathRender(point) : svgPath(point)) : null;
};
Path.defaultProps = {
  data: PropTypes.arrayOf(PropTypes.shape({
    x: PropTypes.number,
    quantity: PropTypes.number
  })).isRequired,
  /** the getX position x on Ox*/
  getX: PropTypes.func,
  /** the getY position y on Oy */
  getY: PropTypes.func,
  /** The color of the line drawn is the default color according to the data returned from the API, otherwise it will be generated by the design. */
  pathColor: PropTypes.string,
  /** shows the line to be drawn */
  PathVisible: PropTypes.bool,
  /** show or hiden the line to be drawn smooth */
  Smooth: PropTypes.bool,
  /** the thickness of the line to be drawn */
  STROKE: PropTypes.number,
  /** the unitWidth */
  unitWidth: PropTypes.number
};
Path.defaultProps = {
  unitWidth: 1,
  PathVisible: true,
  pathColor: '#0095FF',
  Smooth: false,
  STROKE: 2,
  STROKEHover: 3
};
export default Path;